import { Badge, BadgeType } from "@components/new/Badge";

const YmBadge = ({ placementType }: { placementType?: string }) => {
  if (placementType === "Fbs") {
    return (
      <Badge type={BadgeType.PURPLE}>
        FBS
      </Badge>
    );
  }
  if (placementType === "Fby") {
    return (
      <Badge type={BadgeType.PRIMARY}>
        FBP
      </Badge>
    );
  }

  return null;
}

export default YmBadge
